<div (click)="sort()" class="currentSort">
    <ng-content></ng-content>

    <fa name="sort-desc" *ngIf="order == -1" class="sortSymbol"></fa>
    <fa name="sort-asc" *ngIf="order == 1" class="sortSymbol"></fa>
    <fa name="sort" *ngIf="!order" class="sortSymbol up-and-down"></fa>
</div>
